export enum WREX_IMAGE_GALLERY {
    /**
     * @value Up to 15 images
     * @description Helper on the wrex image gallery button to warn the user about the images number limitation
     */
    BUTTON_HELPER = 'WREX_IMAGE_GALLERY.BUTTON_HELPER',
    /**
     * @value Image gallery
     * @description Button label on the wrex image gallery button
     */
    BUTTON_LABEL = 'WREX_IMAGE_GALLERY.BUTTON_LABEL',
    /**
     * @value Insert image gallery (up to 15 images)
     * @description Text editor insert image button tooltip
     */
    BUTTON_TOOLTIP = 'WREX_IMAGE_GALLERY.BUTTON_TOOLTIP',
    /**
     * @value Delete gallery
     */
    DELETE_GALLERY = 'WREX_IMAGE_GALLERY.DELETE_GALLERY',
    /**
     * @value Delete image gallery?
     */
    DELETE_GALLERY_TITLE_CONFIRMATION = 'WREX_IMAGE_GALLERY.DELETE_GALLERY_TITLE_CONFIRMATION',
    /**
     * @value Edit gallery
     */
    EDIT_GALLERY = 'WREX_IMAGE_GALLERY.EDIT_GALLERY',
    /**
     * @value Toolbar of image %INDEX%
     * @description Label used for accessibility, to describe what the toolbar is on the image details of the image gallery dialog. INDEX being the position of the image on the list (first image, second image...)
     */
    IMAGE_GALLERY_DIALOG_DETAILS_TOOLBAR_LABEL = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_DETAILS_TOOLBAR_LABEL',
    /**
     * @value Edit image gallery
     * @description Title of a dialog to edit an image gallery
     */
    IMAGE_GALLERY_DIALOG_EDIT_TITLE = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_EDIT_TITLE',
    /**
     * @value Start building the image gallery by clicking “Add image”.
     * @description Description on the image gallery dialog when no images are picked
     */
    IMAGE_GALLERY_DIALOG_EMPTY_DESCRIPTION = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_EMPTY_DESCRIPTION',
    /**
     * @value No images yet
     * @description Title on the image gallery dialog when no images are picked
     */
    IMAGE_GALLERY_DIALOG_EMPTY_TITLE = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_EMPTY_TITLE',
    /**
     * @value Edit image %INDEX%. Press enter to focus the image details.
     * @description Text read by a screen reader for accessibility when a user focus an image on the image gallery dialog. %INDEX% being the position of the image on the list
     */
    IMAGE_GALLERY_DIALOG_IMAGE_ARIA_LABEL = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_IMAGE_ARIA_LABEL',
    /**
     * @value You can add up to %NB% images to the gallery.
     * @description Message informing the user the max number of images he can add to his gallery
     */
    IMAGE_GALLERY_DIALOG_MESSAGE = 'WREX_IMAGE_GALLERY.IMAGE_GALLERY_DIALOG_MESSAGE',
    /**
     * @value Image gallery toolbar
     */
    TOOLBAR = 'WREX_IMAGE_GALLERY.TOOLBAR',
}
